<template>
  <div class="list-item">
    <div class="item-left">
      <van-image width="100%" height="100%" lazy-load :src="getImgPri()" />
    </div>
    <div class="item-right">
      <div class="right-title">{{ itemData.title }}</div>
      <div class="right-content-f">
        <!-- "tiao": "LF008-07-43-F3",
          "bianma": "LF008",
          "sex": "女性",
          "bituo": "树脂",
          "place": "日本",
          "price": "3080",
          "tuichang": "137",
          "tuikuan": "135~142",
          "bottomText": "色号：奶咖色/07" -->
        <div>{{ itemData.content1 }}</div>
        <!-- <div>镜腿长: {{ itemData.tuichang }} 内宽: {{itemData.tuikuan}}</div> -->
        <div>{{ itemData.content2 }} <span class="arrow-icon"><img src="../../../../assets/img/arrow.png" alt=""></span>
          {{ itemData.content3 }}
        </div>
        <!-- <div>{{ itemData.bituo }}; {{itemData.place}}; </div> -->
      </div>
      <div class="right-content-s">{{ itemData.bottomText }}</div>
    </div>
  </div>
</template>
<script>
  // const isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))
  import Vue from "vue";
  import {
    Image,
    Lazyload
  } from "vant";
  Vue.use(Image);
  Vue.use(Lazyload);
  export default {
    name: 'list-item',
    props: ['itemData', 'img'],
    data() {
      return {
        value: '',
        imgPri: (() => {
          let baseUrl = ''
          try {
            baseUrl = require('@/assets/img/glasl/' + this.img)
          } catch (e) {
            console.log(e)
          }
          return baseUrl
        })()
      }
    },
    mounted() {},
    methods: {
      // goDetail (id) {
      //   this.$router.push(`/detail/${id}`)
      // }
      getImgPri() {
        let baseUrl = ''
        try {
          baseUrl = require('@/assets/img/glasl/' + this.img)
        } catch (e) {
          console.log(e)
        }
        return baseUrl;
      }
    },
  }
</script>
<style lang="less">
  @import '../../../../assets/css/match.less';

  .list-item {
    display: flex;
    background-color: @whitebg;
    padding: 10px;
    border-radius: 8px;

    &:nth-last-of-type(1) {
      margin-bottom: 60/7.5vw;
    }

    .item-left {
      width: 242/7.5vw;
      height: 242/7.5vw;
      margin-right: 46/7.5vw;
      // border: 1px solid #919293;
      border-radius: 20/7.5vw;
      overflow: hidden;
    }

    .textover {
      width: 380/7.5vw;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .item-right {
      .right-title {
        font-size: 34/7.5vw;
        font-weight: bold;
        padding: 18/7.5vw 0 16/7.5vw 0;
        line-height: 1em;
        .textover();
      }

      .right-content-f {
        font-size: 24/7.5vw;
        font-weight: bold;
        .textover();

        &>div {
          line-height: 1.2em;
          color: #919293;
        }

        &>div:nth-of-type(1) {
          padding-top: 6/7.5vw;
          padding-bottom: 8/7.5vw;
        }

        &>div:nth-of-type(2) {
          padding-bottom: 36/7.5vw;
        }
      }

      .right-content-s {
        .textover();
        font-weight: bold;
        color: #383a3c;
        font-size: 24/7.5vw;
        padding-top: 12/7.5vw;
      }
    }

    .arrow-icon {
      display: inline-block;
      transform: translateY(-2/7.5vw);

      img {
        display: inline-block;
        font-size: 0;
        width: 14/7.5vw;
        height: 20/7.5vw;
        vertical-align: middle;
      }
    }
  }
</style>
